module.exports = __webpack_public_path__ + "img/phone.b102f016.png";